import React from 'react'
import { Button, Modal } from 'semantic-ui-react'

export default function SharedModal({
  open,
  ifOngoing,
  onYes,
  onNo,
  onClose,
  header,
  content
}) {
  return (
    <Modal open={open} size="mini" style={{marginLeft: "7%"}} centered={false}>
      <Modal.Header>{header}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          {content}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button 
          secondary 
          onClick={onNo} 
          disabled={ifOngoing} 
          style={{display: onNo ? 'inline' : 'none' }}>
          No
        </Button>
        <Button 
          primary 
          onClick={onYes} 
          loading={ifOngoing} 
          style={{display: onYes ? 'inline' : 'none' }}>
          Yes
        </Button>
        <Button 
          secondary 
          onClick={onClose} 
          style={{display: onClose ? 'inline' : 'none' }}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}


// WEBPACK FOOTER //
// ./utilities/SharedModal.js